var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeaker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.0001 17.225c-.411 0-.797-.255-.942-.665-.185-.521.087-1.092.607-1.277 1.397-.497 2.335-1.816 2.335-3.283s-.938-2.78599-2.335-3.28199c-.521-.186-.792-.757-.607-1.277s.76-.791 1.277-.607c2.192.778 3.665 2.854 3.665 5.16599 0 2.312-1.473 4.388-3.665 5.167-.11.039-.224.058-.335.058z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.0001 21.4489c-.411 0-.797-.255-.942-.665-.185-.521.087-1.092.607-1.277 3.191-1.135 5.335-4.152 5.335-7.507 0-3.35498-2.144-6.37198-5.335-7.50698-.521-.186-.792-.757-.607-1.277.185-.521.759-.792 1.277-.607 3.986 1.417 6.665 5.192 6.665 9.39098 0 4.199-2.679 7.974-6.665 9.392-.11.039-.224.057-.335.057z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 10v4c1.105 0 2-.896 2-2 0-1.105-.895-2-2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.662 3.11212c-.801-.277-1.693-.026-2.224.639l-3.399 4.249h-1.039c-1.654 0-3 1.346-3 2.99998v2c0 1.654 1.346 3 3 3h1.039l3.399 4.249c.387.484.966.751 1.562.751.222 0 .445-.037.662-.112.802-.282 1.338-1.038 1.338-1.888v-13.99998c0-.85-.536-1.606-1.338-1.888z",
    opacity: 0.35
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeaker);
export default __webpack_public_path__ + "static/media/speaker.263b9a9a7f8def89b3a13cb6435a3770.svg";
export { ForwardRef as ReactComponent };